import { render, staticRenderFns } from "./editRoulette.vue?vue&type=template&id=e580e270&"
import script from "./editRoulette.vue?vue&type=script&lang=js&"
export * from "./editRoulette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports